"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnakeCase = exports.simplifyUrl = exports.getDomainFromUrl = exports.computePasswordStrengthNew = exports.computePasswordStrength = exports.bytesToEnglishString = exports.ellipsisRightOnAllStrings = exports.ellipsisRight = exports.randomizeString = exports.removeNonAsciiChars = exports.padZeroes = void 0;
const uuid_1 = require("uuid");
const StringValidators_1 = require("./StringValidators");
const check_password_strength_1 = require("check-password-strength");
const Utils_1 = require("./Utils");
/**
 * Converts a number to decimal with enough leading zeroes to make the result at least places character long.
 */
function padZeroes(num, places) {
    return String(num).padStart(places, "0");
}
exports.padZeroes = padZeroes;
/**
 * Keeps only ascii characters in the input string.
 */
function removeNonAsciiChars(str) {
    let ret = "";
    for (let i = 0; i < str.length; ++i) {
        if (str.charCodeAt(i) > 0 && str.charCodeAt(i) < 128) {
            ret += str.charAt(i);
        }
    }
    return ret;
}
exports.removeNonAsciiChars = removeNonAsciiChars;
/**
 * String randomizer.
 */
function randomizeString(type) {
    switch (type) {
        case "uuid":
        case "uuid-v4":
            return (0, uuid_1.v4)();
        case "jobDisableId":
            return randomizeString("compact-16").slice(0, 15);
        case "compact-2":
        case "compact-4":
        case "compact-6":
        case "compact-8":
        case "compact-12":
        case "compact-16":
        case "compact-20":
        case "compact-32": {
            const compactIdCharSet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const len = Number(type.slice(8));
            let ret = "";
            for (let i = 0; i < len; i++) {
                const r = Math.floor(Math.random() * compactIdCharSet.length);
                ret += compactIdCharSet.slice(r, r + 1);
            }
            return ret;
        }
        default:
            throw new Error(`Unknown random string type ${type}`);
    }
}
exports.randomizeString = randomizeString;
function ellipsisRight(str, maxLength, ellipsis = "...") {
    return str.length <= maxLength ? str : str.substring(0, maxLength - ellipsis.length) + ellipsis;
}
exports.ellipsisRight = ellipsisRight;
function ellipsisRightOnAllStrings(obj, maxLength, ellipsis = "...") {
    return ((0, Utils_1.walkObjectTree)((0, Utils_1.deepClone)(obj), (v) => typeof v === "string" && v.length > maxLength
        ? { replacementValue: ellipsisRight(v, maxLength, ellipsis) }
        : undefined));
}
exports.ellipsisRightOnAllStrings = ellipsisRightOnAllStrings;
var BytesUnit;
(function (BytesUnit) {
    BytesUnit["Bytes"] = "bytes";
    BytesUnit["KB"] = "KB";
    BytesUnit["MB"] = "MB";
    BytesUnit["GB"] = "GB";
    BytesUnit["TB"] = "TB";
    BytesUnit["PB"] = "PB";
    BytesUnit["EB"] = "EB";
})(BytesUnit || (BytesUnit = {}));
function bytesToEnglishString(bytes, extraPrecision = 0, forcedUnit) {
    var _a;
    if (forcedUnit) {
        let d = bytes;
        for (let i = 0; i < Object.keys(BytesUnit).indexOf(forcedUnit); i++) {
            d /= 1024.0;
        }
        return `${Number(d).toFixed(extraPrecision)} ${forcedUnit}`;
    }
    if (bytes < 1024) {
        return `${bytes} bytes`;
    }
    let unitIndex = 1;
    let d = bytes / 1024.0;
    while (d > 999.4) {
        d /= 1024.0;
        unitIndex++;
    }
    const unit = (_a = Object.keys(BytesUnit)[unitIndex]) !== null && _a !== void 0 ? _a : "?B";
    const precision = d >= 100.0 ? 0 : d >= 10.0 ? 1 : 2;
    return `${Number(d).toFixed(precision + extraPrecision)} ${unit}`;
}
exports.bytesToEnglishString = bytesToEnglishString;
// DEPRECATED
function computePasswordStrength(password) {
    const checklist = [
        /[`~!@#$%^&*()_+-=<>?:{}|,./;'[\]\\]/.test(password),
        /[0-9]/.test(password),
        /[A-Z]/.test(password),
        /[a-z]/.test(password),
        password.length >= 10,
    ];
    return checklist.reduce((acc, next) => (next ? acc + 1 : acc), 0);
}
exports.computePasswordStrength = computePasswordStrength;
function computePasswordStrengthNew(password) {
    password = password.trim();
    const res = (0, check_password_strength_1.passwordStrength)(password, [
        {
            id: 0,
            value: "blank",
            minDiversity: 0,
            minLength: 0,
        },
        {
            id: 1,
            value: "very-weak",
            minDiversity: 0,
            minLength: 1,
        },
        {
            id: 2,
            value: "weak",
            minDiversity: 2,
            minLength: 6,
        },
        {
            id: 3,
            value: "medium",
            minDiversity: 3,
            minLength: 7,
        },
        {
            id: 4,
            value: "strong",
            minDiversity: 4,
            minLength: 8,
        },
        {
            id: 5,
            value: "very-strong",
            minDiversity: 4,
            minLength: 10,
        },
    ]);
    return {
        password,
        strength: res.value,
        strongEnough: res.value.includes("strong"),
        contains: res.contains,
        length: res.length,
    };
}
exports.computePasswordStrengthNew = computePasswordStrengthNew;
/**
 * Gets domain name from a full website url.
 */
function getDomainFromUrl(url) {
    try {
        return new URL(url).hostname;
    }
    catch (err) {
        return url.replace(/.+\/\/|www.|\..+/g, "");
    }
}
exports.getDomainFromUrl = getDomainFromUrl;
/**
 * Simplify a web url. This is a lossy operation.
 * Returns the original url if malformed.
 *
 * Examples:
 *   - "football://mylogin:mypwd@www1.foo.bar.ca:333/bim/bam?hoo=hic&l#frag" => "foo.bar.ca/bim/bam"
 *   - "https://docs.google.com/document/d/16uw3YG94HmdDBfDsgayKGf6kEPJuE/edit#heading=h.5c0mi4amlhzm" => "docs.google.com/document/d/16uw3yg94hmddbfdsgaykgf6kepjue/edit"
 *
 * Reminder about the URL object:
 *   new URL('http://mylogin:mypwd@foo.bar.ca:333/bim/bam?hoo=hic&l#frag')           =>   URL {
 *        href: 'http://mylogin:mypwd@foo.bar.ca:333/bim/bam?hoo=hic&l#frag',
 *        origin: 'http://foo.bar.ca:333',
 *        protocol: 'http:',
 *        username: 'mylogin',
 *        password: 'mypwd',
 *        host: 'foo.bar.ca:333',
 *        hostname: 'foo.bar.ca',
 *        port: '333',
 *        pathname: '/bim/bam',
 *        search: '?hoo=hic&l',
 *        searchParams: URLSearchParams { 'hoo' => 'hic', 'l' => '' },
 *        hash: '#frag'
 *      }
 */
function simplifyUrl(url) {
    url = url.trim().toLowerCase();
    const validity = (0, StringValidators_1.validateUrl)(url, { maxLength: 10000 });
    if (validity.includes("malformedURL")) {
        return url;
    }
    if (validity.includes("absentProtocol")) {
        url = `http://${url}`;
    }
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www[0-9]*\./g, "") + parsed.pathname.replaceAll(/\/{2,}/g, "/").replace(/\/+$/g, "");
}
exports.simplifyUrl = simplifyUrl;
function toSnakeCase(str) {
    var _a;
    return (_a = str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _a === void 0 ? void 0 : _a.map((x) => x.toLowerCase()).join("_");
}
exports.toSnakeCase = toSnakeCase;
//# sourceMappingURL=String.js.map